export default "__VITE_ASSET__CyDPo285__"